import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import logo from '../../Assets/Images/loaderlogoimg.png'

const Loader = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 100,
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={logo}
          alt="Loading"
          style={{ width: 60, height: 60, zIndex: 1, borderRadius:"50%" }}
        />
        <CircularProgress
          size={100}
          thickness={3}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            color: "#1976d2",
            animationDuration: "0.3s",
            animationDirection: "reverse",
          }}
        />
        <CircularProgress
          size={100}
          thickness={3}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            color: "#1976d241",
            animationDuration: "0.4s",
            animationDirection: "reverse",
          }}
        />

        <CircularProgress
          size={120}
          thickness={3}
          sx={{
            position: "absolute",
            top: -10,
            left: -10,
            color: "#E75E1F",
            animationDuration: "0.4s",
            animationDirection: "reverse",
            
          }} 
        />
        <CircularProgress
          size={120}
          thickness={3}
          sx={{
            position: "absolute",
            top: -10,
            left: -10,
            color: "#e75e1f48",
            animationDuration: "0.3s",
            animationDirection: "reverse",
            
          }} 
        />
        
         
      </Box>
    </Box>
  );
};

export default Loader;
